import { SAVE_PHONE_NUMBERS_ACTION } from "../reducers/phoneNumbersReducers.js";

const savePhoneNumbers = data => ({
    type: SAVE_PHONE_NUMBERS_ACTION,
    phoneNumbers: data
});

export default { savePhoneNumbers }